module.exports = __webpack_public_path__ + "img/worksbot_img20022501.dfdac48c.jpg";